//Method for get client address for client
export function getClientAddress() {
  if (typeof window !== 'undefined') {
    const geoIp = localStorage.getItem('geoip');
    if (geoIp && new Date().getTime() < JSON.parse(geoIp).expiry) {
      const clientAddress = JSON.parse(geoIp);
      return clientAddress;
    }
  }

  fetch('https://geoip.cactusglobal.io/json/', {
    method: 'GET',
  })
    .then((result) => result.json())
    .then((result) => {
      const expire = new Date();
      const time = Date.now() + 3600 * 1000 * 24;
      expire.setTime(time);
      result.expiry = expire.getTime();
      if (!result.country_code) {
        result.country_code = 'US';
      }
      localStorage.setItem('geoip', JSON.stringify(result));
      return result;
    })
    .catch(() => {
      return null;
    });
}
